import { useEffect, useState } from "react";
import { Gauge } from "lucide-react";
import { fetchAltares } from "@/lib/dossiers";
import { isImmatriculation } from "@/lib/dossiers";

const TONES = {
    Faible: "border-emerald-300 bg-emerald-50 text-emerald-800",
    "Modéré": "border-amber-300 bg-amber-50 text-amber-800",
    "Élevé": "border-orange-300 bg-orange-50 text-orange-800",
    Critique: "border-rose-300 bg-rose-50 text-rose-800",
};

export default function AltaresBadge({ siren }) {
    const [data, setData] = useState(null);
    useEffect(() => {
        if (!siren || isImmatriculation(siren)) return;
        fetchAltares(siren).then(setData).catch(() => setData(null));
    }, [siren]);
    if (!data) return null;
    return (
        <div data-testid="altares-badge" className={`rounded-md border px-3 py-2 text-xs ${TONES[data.indicateur_risque] || TONES.Faible}`} title={data.libelle_source}>
            <div className="flex items-center gap-2">
                <Gauge className="h-3.5 w-3.5" strokeWidth={1.75} />
                <span className="font-semibold uppercase tracking-wider">Risque {data.indicateur_risque}</span>
                <span data-testid="altares-mock-tag" className="ml-1 rounded-full bg-black/10 px-2 py-0.5 text-[10px] uppercase tracking-wider">Mock Altares</span>
            </div>
            <p className="mt-1 tabular-nums">
                Score défaillance <span data-testid="altares-score" className="font-semibold">{data.score_defaillance}/100</span> · Retard paiement BdF <span data-testid="altares-retard" className="font-semibold">{data.retard_paiement_bdf} j</span>
            </p>
        </div>
    );
}
